import React, { useState } from "react";
import { Box } from "@mui/material";
import { BsX } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import Papa from "papaparse";
const baseURL = process.env.REACT_APP_URL;

const CsvUploader = ({
  onClose = () => { },
  tableColumns = [],
  requiredFields = [],
  model = undefined,
  match_field = undefined
}) => {

  const navigate = useNavigate();
  const location = useLocation();

  const { data, title, prevNav } = location.state || {};

  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [mapping, setMapping] = useState({});
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState(null);
  const [importReport, setImportReport] = useState(null);

  const autoSuggestMapping = (headerRow) => {

    const autoMap = {};

    headerRow.forEach((header) => {

      const normalizedHeader = header
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");

      const match = tableColumns.find((column) => {

        const normalizedColumn = column
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");

        return (
          normalizedColumn === normalizedHeader ||
          normalizedHeader.includes(normalizedColumn) ||
          normalizedColumn.includes(normalizedHeader)
        );
      });

      if (match) {
        autoMap[header] = match;
      }
    });

    setMapping(autoMap);
  };

  const handleFileUpload = (e) => {

    const selectedFile = e.target.files?.[0];

    if (!selectedFile) return;

    setFile(selectedFile);

    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,

      complete: (result) => {

        const parsedHeaders =
          result.meta.fields || [];

        setHeaders(parsedHeaders);

        setRows(result.data || []);

        autoSuggestMapping(parsedHeaders);
      },

      error: (error) => {
        alert(error.message);
      }
    });
  };

  const handleMappingChange = (
    csvHeader,
    tableColumn
  ) => {

    setMapping((prev) => ({
      ...prev,
      [csvHeader]: tableColumn
    }));
  };

  const validateRequired = () => {

    const mappedValues =
      Object.values(mapping);

    return requiredFields.filter(
      (field) =>
        !mappedValues.includes(field)
    );
  };

  const handleUpload = async () => {

    const missing =
      validateRequired();

    if (missing.length) {

      alert(
        `Missing required fields: ${missing.join(", ")}`
      );

      return;
    }

    if (!file) {

      alert(
        "Please select a CSV file"
      );

      return;
    }

    try {

      setUploading(true);

      setProgress(10);

      const formData =
        new FormData();

      formData.append(
        "file",
        file
      );
      if (!model) {
        alert("Model not found");
        return;
      }

      formData.append(
        "model",
        model
      );

      formData.append(
        "mapping",
        JSON.stringify(mapping)
      );

      formData.append(
        "match_field",
        match_field || null
      );

      setProgress(30);

      const response =
        await fetch(
          baseURL + "import/",
          {
            method: "POST",
            body: formData
          }
        );

      setProgress(75);

      const result =
        await response.json();

      if (!response.ok) {

        throw new Error(
          result.error ||
          result.detail ||
          "Import failed"
        );
      }

      setProgress(100);

      setImportReport(result);

      alert(`
Total Rows : ${result.total_rows || 0}

Created : ${result.created || 0}

Updated : ${result.updated || 0}

Failed : ${result.failed || 0}
            `);

    } catch (error) {

      console.error(error);

      alert(
        error.message ||
        "Import failed"
      );

    } finally {

      setUploading(false);
    }
  };

  const missingFields =
    validateRequired();

  return (
    <div
      style={{
        padding: 20,
      }}
      className="card-bg shadow"
    >
      <div style={{ padding: 10 }}>

        <Box
          sx={{
            display: "flex",
            justifyContent:
              "space-between"
          }}
        >
          <Box
            sx={{
              fontWeight: "bold",
              fontSize: 14,
              mb: 3,
              textAlign: "center"
            }}
          >
            Import & Mapping for {title}
          </Box>

          <Box
            className="round danger"
          >
            <BsX
              onClick={() =>
                navigate(
                  prevNav
                )
              }
            />
          </Box>
        </Box>

        <input
          type="file"
          accept=".csv"
          onChange={
            handleFileUpload
          }
        />
        <div style={{ overflowX: 'auto', }}>
          {headers.length > 0 && (
            <div
              style={{
                marginTop: 30,
                maxWidth: 200,
                paddingBottom: 10
              }}
            >
              <h3>
                Preview & Map Columns
              </h3>

              <table
                cellPadding="8"
                style={{
                  border:
                    "1px solid #dedede",
                  borderRadius: 10,
                  borderCollapse:
                    "collapse",
                  width: "100%"
                }}
              >
                <thead>
                  <tr>
                    {headers.map(
                      (
                        header
                      ) => {

                        const isMapped =
                          !!mapping[
                          header
                          ];

                        return (
                          <th
                            key={
                              header
                            }
                            style={{
                              background:
                                isMapped
                                  ? "#f0f8ff"
                                  : "#ffecec"
                            }}
                          >
                            <div
                              style={{
                                display:
                                  "flex",
                                flexDirection:
                                  "column"
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 12
                                }}
                              >
                                {
                                  header
                                }
                              </span>

                              <select
                                value={
                                  mapping[
                                  header
                                  ] ||
                                  ""
                                }
                                onChange={(
                                  e
                                ) =>
                                  handleMappingChange(
                                    header,
                                    e
                                      .target
                                      .value
                                  )
                                }
                                style={{
                                  marginTop: 5,
                                  minWidth: 200
                                }}
                              >
                                <option value="">
                                  Map to...
                                </option>

                                {tableColumns.map(
                                  (
                                    col
                                  ) => (
                                    <option
                                      key={
                                        col
                                      }
                                      value={
                                        col
                                      }
                                    >
                                      {
                                        col
                                      }
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </th>
                        );
                      }
                    )}
                  </tr>
                </thead>

                <tbody>
                  {rows
                    .slice(
                      0,
                      5
                    )
                    .map(
                      (
                        row,
                        index
                      ) => (
                        <tr
                          key={
                            index
                          }
                          style={{
                            background:
                              index %
                                2 ===
                                0
                                ? "#f5f5f5"
                                : "#fff"
                          }}
                        >
                          {headers.map(
                            (
                              header
                            ) => (
                              <td
                                key={
                                  header
                                }
                              >
                                {
                                  row[
                                  header
                                  ]
                                }
                              </td>
                            )
                          )}
                        </tr>
                      )
                    )}
                </tbody>
              </table>

              {missingFields.length >
                0 && (
                  <div
                    style={{
                      color:
                        "red",
                      marginTop: 15
                    }}
                  >
                    Missing
                    required
                    fields:
                    {" "}
                    {missingFields.join(
                      ", "
                    )}
                  </div>
                )}

              <button
                className="primary"
                onClick={
                  handleUpload
                }
                disabled={
                  uploading
                }
                style={{
                  marginTop: 20,
                  border: "none",
                  borderRadius: 10,
                  padding:
                    "10px 20px"
                }}>
              
                {uploading
                  ? "Uploading..."
                  : "Upload Data"}
              </button>

              {uploading && (
                <div
                  style={{
                    marginTop: 15
                  }}
                >
                  <div
                    style={{
                      height: 10,
                      width:
                        "100%",
                      background:
                        "#ddd",
                      borderRadius: 5
                    }}
                  >
                    <div
                      style={{
                        height:
                          "100%",
                        width: `${progress}%`,
                        background:
                          "green",
                        transition:
                          "width .3s",
                        borderRadius: 5
                      }}
                    />
                  </div>

                  <div
                    style={{
                      marginTop: 5
                    }}
                  >
                    {progress}%
                  </div>
                </div>
              )}

              {importReport && (
                <div
                  style={{
                    marginTop: 20,
                    padding: 15,
                    border:
                      "1px solid #ddd",
                    borderRadius: 10
                  }}
                >
                  <h4>
                    Import
                    Report
                  </h4>

                  <p>
                    Total
                    Rows:
                    {" "}
                    {importReport.total_rows ||
                      0}
                  </p>

                  <p>
                    Created:
                    {" "}
                    {importReport.created ||
                      0}
                  </p>

                  <p>
                    Updated:
                    {" "}
                    {importReport.updated ||
                      0}
                  </p>

                  <p>
                    Failed:
                    {" "}
                    {importReport.failed ||
                      0}
                  </p>

                  {importReport.report_url && (
                    <a
                      href={
                        importReport.report_url
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download
                      Error
                      Report
                    </a>
                  )}
                </div>
              )}

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CsvUploader;
